import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "button-row" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center status-with-tooltip" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_5 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_api_import_selection_modal = _resolveComponent("api-import-selection-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      gutter: $setup.spacingWidthHeaderComponents,
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          ($setup.runnableApiNextRuns.length)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showRunMultipleModal = true))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('runMultipleApiImports')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($setup.apiConnectionConfigurations.length)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "info",
                class: "configure-button",
                onClick: $setup.navigateToConfiguration
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('configureApiImports')), 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowRight)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["gutter"]),
    _createVNode(_component_el_row, { gutter: $setup.spacingWidthHeaderComponents }, {
      default: _withCtx(() => [
        _createVNode(_component_base_table, {
          "show-loading-table": $setup.showLoadingTable,
          "show-no-content-table": !$setup.apiNextRuns.length,
          "error-message": _ctx.$t('noApiNextRunsToDisplay')
        }, {
          default: _withCtx(() => [
            ($setup.apiNextRuns.length)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: $setup.apiNextRuns
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('outputFileName'),
                      "min-width": "200"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("h4", null, _toDisplayString(scope.row.outputFileName), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('apiConnectionName'),
                      "min-width": "200"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("h4", null, _toDisplayString($setup.getApiNameKey(scope.row.apiName)), 1),
                          ($setup.isApiConnectionDisabled(scope.row.apiName))
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                placement: "top",
                                content: _ctx.$t('apiConnectionDisabledWarning')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, { class: "ml-2 color-red" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WarningFilled)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["content"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('nextRun'),
                      "min-width": "180"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("h4", null, _toDisplayString($setup.formatTimestamp(scope.row.nextRunTimestamp)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('scheduleCalculationResult'),
                      "min-width": "180"
                    }, {
                      default: _withCtx((scope) => [
                        (
                scope.row.statusMessage &&
                scope.row.nextRunCalculationResult !== 0
              )
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              placement: "top",
                              content: scope.row.statusMessage
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_component_el_icon, {
                                    class: _normalizeClass([
                    $setup.getStatusInfo(scope.row.nextRunCalculationResult).colorClass
                  , "mr-1"])
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getStatusInfo(scope.row.nextRunCalculationResult).icon)))
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createElementVNode("span", null, _toDisplayString($setup.getStatusInfo(scope.row.nextRunCalculationResult).text), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_el_icon, {
                                class: _normalizeClass([
                  $setup.getStatusInfo(scope.row.nextRunCalculationResult).colorClass
                , "mr-1"])
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getStatusInfo(scope.row.nextRunCalculationResult).icon)))
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createElementVNode("span", null, _toDisplayString($setup.getStatusInfo(scope.row.nextRunCalculationResult).text), 1)
                            ]))
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, { "min-width": "120" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_5, [
                          ($setup.canRunImport(scope.row))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                size: "small",
                                class: "ml-auto",
                                onClick: ($event: any) => (
                  $setup.runApiImports([
                    {
                      apiName: scope.row.apiName,
                      outputFileName: scope.row.outputFileName
                    }
                  ])
                )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('runNow')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show-loading-table", "show-no-content-table", "error-message"])
      ]),
      _: 1
    }, 8, ["gutter"]),
    _createVNode(_component_api_import_selection_modal, {
      "dialog-visible": $setup.showRunMultipleModal,
      "api-next-runs": $setup.runnableApiNextRuns,
      "modal-title": _ctx.$t('selectApiImportsToRun'),
      onConfirm: $setup.handleRunMultipleConfirm,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showRunMultipleModal = false))
    }, null, 8, ["dialog-visible", "api-next-runs", "modal-title", "onConfirm"])
  ], 64))
}